import { Stack, Typography, useTheme } from "@mui/material";

interface VehicleFeaturesProps {
  kmDriven?: string;
  fuelType?: string;
  gearType?: string;
}

const FeatureItem = ({ label }: { label?: string }) => (
  <Stack
    sx={{
      display: "flex",
      alignItems: "center",
      gap: 0.5,
      justifyContent: "center",
      flexDirection: "row",
    }}
  >
    <Typography
      fontFamily="Work Sans"
      fontWeight="400"
      fontSize={{ xs: 11, sm: 13 }}
      color="#414141ff"
    >
      {label}
    </Typography>
  </Stack>
);

const VehicleFeatures = ({
  kmDriven,
  fuelType,
  gearType,
}: VehicleFeaturesProps) => {
  const theme = useTheme();

  return (
    <Stack
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        px: 0,
        py: 1,
        flexWrap: "wrap",
        flexDirection: "row",
      }}
    >
      {kmDriven?.length !== 0 &&<FeatureItem label={`${kmDriven} Km`} />}
      <FeatureItem label={fuelType} />
      <FeatureItem label={gearType} />
    </Stack>
  );
};

export { VehicleFeatures };
